import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Invitation from './pages/invitation/Invitation';
import AfterpartyInvitation from './pages/afterparty/Invitation';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/invitation" element={<Invitation />} />
        <Route path="/afterparty" element={<AfterpartyInvitation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;